import React, { Component } from 'react';

import './form.styles.scss';

class Form extends Component {
    componentDidMount() {
        const script = document.createElement('script');
        script.src = 'https://js.hsforms.net/forms/v2.js';
        document.body.appendChild(script);

        script.addEventListener('load', () => {
            if (window.hbspt) {
                window.hbspt.forms.create({
                    portalId: '2719325',
                    formId: 'f8be0243-3c37-4e98-be47-1d39d1b37fb9',
                    target: '#hubspot-form'
                })
            }
        })
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="container">
                    <div className="content-wrapper">
                        <h2>Want to share an example of your own?</h2>
                        <p>We are looking for examples of how travel & tourism businesses are responding to the COVID-19 global pandemic. Fill in the form below to enter your submission.</p>
                    </div>
                    <div id="hubspot-form"></div>
                </div>
            </div>
        )
    }
}

export default Form;